import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core'
import config from '../../config/config.json';

export default function (props) {
    const ejemplo = [
        [
            { campo: 'nombre', tipo: 'string', valor: 'el-huracan-mas-poderoso', descripcion: 'Identificador de la noticia.' },
            { campo: 'titulo', tipo: 'string', valor: 'El huracán mas poderoso', descripcion: 'Título de la noticia.' },
            { campo: 'foto', tipo: 'url', valor: '{config.apiBaseUrl}/files/noticias/Huracan_patricia_23-101.jpg.jpg', descripcion: 'Foto principal de la noticia.' },
            { campo: 'texto', tipo: 'string', valor: 'El huracán Patricia fue el ciclón tropical más intenso jamás observado en el hemisferio occidental en ', descripcion: 'Texto de la noticia.' },
            { campo: 'autor', tipo: 'string', valor: 'Guillermo Puentes Montesino', descripcion: 'Autor de la noticia.' },
            { campo: 'fecha', tipo: 'date', valor: '14/02/2021', descripcion: 'Fecha de la noticia.' },
            { campo: 'categoria', tipo: 'string', valor: 'Ciclones Tropicales', descripcion: 'Categoría de la noticia.' },
            { campo: 'categoria_slug', tipo: 'string', valor: 'ciclones-tropicales', descripcion: 'Identificador de la categoría a la que pertenece la alerta.' },
        ],
        [
            { campo: 'nombre', tipo: '', valor: 'que-son-las-alertas-meteorologicas-', descripcion: '' },
            { campo: 'titulo', tipo: '', valor: 'Que son las alertas meteorológicas?', descripcion: '' },
            { campo: 'foto', tipo: '', valor: '{config.apiBaseUrl}/files/noticias/Shallow_water_wave1.gif', descripcion: '' },
            { campo: 'texto', tipo: '', valor: 'Se llama alerta al período anterior a la ocurrencia de un desastre, declarado con el fin de tomar precauciones generales', descripcion: '' },
            { campo: 'autor', tipo: '', valor: 'Pepe Coca Lopez', descripcion: '' },
            { campo: 'fecha', tipo: '', valor: '25/01/2021', descripcion: '' },
            { campo: 'categoria', tipo: '', valor: 'Alertas', descripcion: '' },
            { campo: 'categoria_slug', tipo: '', valor: 'alertas', descripcion: '' },
        ],
        [
            { campo: 'nombre', tipo: '', valor: 'cuba-amplia-red-de-del-servicio-sismologico-nacional', descripcion: '' },
            { campo: 'titulo', tipo: '', valor: 'Cuba amplía red de del Servicio Sismológico Nacional', descripcion: '' },
            { campo: 'foto', tipo: '', valor: '{config.apiBaseUrl}/files/noticias/noticia4.jpg', descripcion: '' },
            { campo: 'texto', tipo: '', valor: 'La red de estaciones del Servicio Sismológico Nacional (SSN) continúa hoy su ampliación en pos de optimizar el monitoreo de los terremotos y expa', descripcion: '' },
            { campo: 'autor', tipo: '', valor: 'Federico Gonzales Moraga', descripcion: '' },
            { campo: 'fecha', tipo: '', valor: '22/11/2016', descripcion: '' },
            { campo: 'categoria', tipo: '', valor: 'Ciencia', descripcion: '' },
            { campo: 'categoria_slug', tipo: '', valor: 'ciencia', descripcion: '' },
        ],
    ];

    return (
        <>
            <Typography variant="h5" color="initial">
                <code>
                    Noticias
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Lo que es noticia en Meteorología Santiago de Cuba.
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/noticias</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/noticias`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/noticias
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve las últimas 20 noticias en caso de que existan; de lo contrario una lista vacía <code>[ ]</code>. Donde cada noticia es representada por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo: <br /> {/* Ejemplo de respuesta */}
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                {
                    ejemplo.map((item) => (
                        <>
                            <div>{`{`}</div>
                            {
                                item.map((subitem) => (
                                    <div><span className="pre-key">"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                ))
                            }
                            <div>{`}`},</div>
                        </>
                    ))
                }
                <div>...,</div>
                <div>...,</div>
                <div>...,</div>
                ]
            </pre>

            <Typography variant="subtitle1" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ejemplo.map((item, index) => {
                            if (index == 0) {
                                return (
                                    item.map((subitem) => (
                                        <tr>
                                            <td>{subitem.campo}</td>
                                            <td>{subitem.tipo}</td>
                                            <td>{subitem.descripcion}</td>
                                        </tr>
                                    ))
                                )
                            }
                        })
                    }
                </tbody>
            </table>
            <br />

            {/* otro ejemplo de peticion */}
            <Typography variant="h6" color="initial">
                <code>
                    Obteniendo una cantidad de noticias deseada.
                </code>
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/noticias/{`{`}cant{`}`}</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/noticias/5`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/noticias/{`{`}cant{`}`}
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve las últimas <code>{`{ `}cant{` }`}</code> noticias en caso de que existan; de lo contrario una lista vacía <code>[ ]</code>. Donde cada noticia es representada por un objeto.
            </Typography>
            <br />

            <Typography variant="subtitle1" color="initial">
                Ejemplo de url para obtener las 5 últimas noticias: <br />
            </Typography>
            <br />

            <pre>
                {config.apiBaseUrl}/noticias/5
            </pre>
            <br />

            <Typography variant="subtitle1" color="initial">
                Ejemplo de respuesta. <br />
            </Typography>
            <br />

            <pre>
                Ver ejemplo anterior, estando limitada la cantidad de noticias a 5.
            </pre>
            <br />
        </>
    )
}